export default {
  notification: {
    title: 'Notification',
    description: 'Once your prescription has been processed, you\'ll receive a text from us containing your unique prescription ID & dispensing link for the pharmacy: https://pharmacy.healistic.net/dispense',
    image: '/images/help/messages.png',
  },
  visit: {
    title: 'Visit pharmacy',
    description: 'Take this code to a pharmacy of your choosing¹',
    extra: '¹ Excluding Boots Pharmacies',
    image: '/images/help/medkit.png',
  },
  details: {
    title: 'Provide details to pharmacy',
    description: 'Provide the pharmacist with the dispensing link - they will then need your prescription ID number and date of birth',
    image: '/images/help/notification.png',
  },
  dispensing: {
    title: 'Dispensing',
    description: 'The pharmacist will be able to view your digital prescription and dispense your medication',
    image: '/images/help/receipt.png',
  },
};
